import { ACCOUNT_TOKENS } from '@elementary/common-ui/constants/queryKeys';
import { TokenConfig, TokenApi } from '../shared/types';
import TokensPage from '../shared/TokensPage';
import * as api from './services/api';

const AccountTokens = () => {
  const tokenApi: TokenApi = {
    getTokens: api.getAccountTokens,
    createToken: api.createAccountToken,
    deleteToken: api.deleteAccountToken,
  };

  const config: TokenConfig = {
    queryKey: [ACCOUNT_TOKENS],
    api: tokenApi,
    tokenType: 'account',
    successMessages: {
      create: 'Account token created successfully',
      delete: 'Account token deleted successfully',
      createError: 'Failed to create account token',
      deleteError: 'Failed to delete account token',
    },
  };

  return (
    <TokensPage
      config={config}
      breadcrumbs={['Account', 'Account Tokens']}
      pageTitle="Account tokens"
      urlParamsPrefix="account_tokens_table"
    />
  );
};

export default AccountTokens;
